// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin: 0 0 1.5714286rem;
}
:host .card-wrap {
  background-color: #fff;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid #fff;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;
}
:host .card-wrap:not(.outline-card) {
  border: 0 !important;
}
:host .card-wrap .card-header {
  background: #3c4e62;
  border-radius: 0;
  color: #fff;
  display: block;
  margin: -1px -1px 0 -1px;
  padding: 0.7857143rem 1.5714286rem;
  position: relative;
}
:host .card-wrap .card-content {
  display: block;
  padding: 1.5714286rem;
  position: relative;
}
:host .card-wrap.success-card {
  background: #008000;
  border-color: #008000;
}
:host .card-wrap.success-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.info-card {
  background: #00bfff;
  border-color: #00bfff;
}
:host .card-wrap.info-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.warning-card {
  background: #ff8c00;
  border-color: #ff8c00;
}
:host .card-wrap.warning-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.danger-card {
  background: #dc143c;
  border-color: #dc143c;
}
:host .card-wrap.danger-card:not(.outline-card) {
  color: #fff;
}
:host .card-wrap.success-color-card {
  color: #008000;
}
:host .card-wrap.info-color-card {
  color: #00bfff;
}
:host .card-wrap.warning-color-card {
  color: #ff8c00;
}
:host .card-wrap.danger-color-card {
  color: #dc143c;
}
:host .card-wrap.outline-card {
  background: none !important;
  box-shadow: none !important;
}
:host .card-wrap.bg-image-card {
  border: none !important;
}
:host .card-wrap.bg-image-card:before {
  background-color: inherit;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/rt-components/card/card.component.scss","webpack://./src/assets/sass/_variable.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,wBAAA;AADF;AAGE;EACE,sBAAA;EACA,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,kBAAA;AADJ;AAGI;EACE,oBAAA;AADN;AAGI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,kCAAA;EACA,kBAAA;AADN;AAGI;EACE,cAAA;EACA,qBCzBG;ED0BH,kBAAA;AADN;AAGI;EACE,mBCRU;EDSV,qBCTU;ADQhB;AAGM;EACE,WAAA;AADR;AAII;EACE,mBCfO;EDgBP,qBChBO;ADcb;AAIM;EACE,WAAA;AAFR;AAKI;EACE,mBCtBU;EDuBV,qBCvBU;ADoBhB;AAKM;EACE,WAAA;AAHR;AAMI;EACE,mBC7BS;ED8BT,qBC9BS;AD0Bf;AAMM;EACE,WAAA;AAJR;AAOI;EACE,cCxCU;ADmChB;AAOI;EACE,cC1CO;ADqCb;AAOI;EACE,cC5CU;ADuChB;AAOI;EACE,cC9CS;ADyCf;AAOI;EACE,2BAAA;EACA,2BAAA;AALN;AAOI;EACE,uBAAA;AALN;AAOM;EACE,yBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AALR","sourcesContent":["@import '../../../assets/sass/variable';\r\n\r\n:host {\r\n  display: block;\r\n  margin: 0 0 $module;\r\n\r\n  .card-wrap {\r\n    background-color: #fff;\r\n    background-position: 50% 50%;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    border: 1px solid #fff;\r\n    box-shadow: 1px 1px 5px 0px rgba(#000,.25);\r\n    position: relative;\r\n\r\n    &:not(.outline-card) {\r\n      border: 0 !important;\r\n    }\r\n    .card-header {\r\n      background: main-color(500);\r\n      border-radius: 0;\r\n      color: #fff;\r\n      display: block;\r\n      margin: -1px -1px 0 -1px;\r\n      padding: $module/2 $module;\r\n      position: relative;\r\n    }\r\n    .card-content {\r\n      display: block;\r\n      padding: $module;\r\n      position: relative;\r\n    }\r\n    &.success-card {\r\n      background: $success-color;\r\n      border-color: $success-color;\r\n\r\n      &:not(.outline-card) {\r\n        color: #fff;\r\n      }\r\n    }\r\n    &.info-card {\r\n      background: $info-color;\r\n      border-color: $info-color;\r\n\r\n      &:not(.outline-card) {\r\n        color: #fff;\r\n      }\r\n    }\r\n    &.warning-card {\r\n      background: $warning-color;\r\n      border-color: $warning-color;\r\n\r\n      &:not(.outline-card) {\r\n        color: #fff;\r\n      }\r\n    }\r\n    &.danger-card {\r\n      background: $danger-color;\r\n      border-color: $danger-color;\r\n\r\n      &:not(.outline-card) {\r\n        color: #fff;\r\n      }\r\n    }\r\n    &.success-color-card {\r\n      color: $success-color;\r\n    }\r\n    &.info-color-card {\r\n      color: $info-color;\r\n    }\r\n    &.warning-color-card {\r\n      color: $warning-color;\r\n    }\r\n    &.danger-color-card {\r\n      color: $danger-color;\r\n    }\r\n    &.outline-card {\r\n      background: none !important;\r\n      box-shadow: none !important;\r\n    }\r\n    &.bg-image-card {\r\n      border: none !important;\r\n\r\n      &:before {\r\n        background-color: inherit;\r\n        content: '';\r\n        display: block;\r\n        height: 100%;\r\n        left: 0;\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}","$main-fs: 14px;\r\n$main-ff: 'Open Sans', sans-serif;\r\n$main-fw: 400;\r\n$main-lh: 1.5714286;\r\n$module: 1.5714286rem;\r\n\r\n$second-ff: 'Nunito Sans', sans-serif;\r\n\r\n$animation: ease-in-out;\r\n\r\n$sidebar-width: 220px;\r\n\r\n$max543 : only screen and (max-width: 543px);\r\n$min544 : only screen and (min-width: 544px);\r\n$max767 : only screen and (max-width: 767px);\r\n$min768 : only screen and (min-width: 768px);\r\n$max991 : only screen and (max-width: 991px);\r\n$min992 : only screen and (min-width: 992px);\r\n$max1199 : only screen and (max-width: 1199px);\r\n$max2048 : only screen and (max-width: 2048px);\r\n$min1200 : only screen and (min-width: 1200px);\r\n\r\n$headers-ff: $second-ff;\r\n$headers-fw: 700;\r\n\r\n$success-color: #008000;\r\n$info-color: #00bfff;\r\n$warning-color: #ff8c00;\r\n$danger-color: #dc143c;\r\n\r\n$main-color: (\r\n  50 : #e8eaec,\r\n  100 : #c5cad0,\r\n  200 : #9ea7b1,\r\n  300 : #778391,\r\n  400 : #59697a,\r\n  500 : #3c4e62,\r\n  600 : #36475a,\r\n  700 : #2e3d50,\r\n  800 : #273546,\r\n  900 : #1a2534,\r\n  A100 : #5dade0,\r\n  A200 : #2694d9,\r\n  A400 : #0e7cc5,\r\n  A700 : #03568b,\r\n  contrast: (\r\n    50 : #000000,\r\n    100 : #000000,\r\n    200 : #000000,\r\n    300 : #000000,\r\n    400 : #ffffff,\r\n    500 : #ffffff,\r\n    600 : #ffffff,\r\n    700 : #ffffff,\r\n    800 : #ffffff,\r\n    900 : #ffffff,\r\n    A100 : #ffffff,\r\n    A200 : #ffffff,\r\n    A400 : #ffffff,\r\n    A700 : #ffffff,\r\n  )\r\n);\r\n@function main-color($key: $main-color) {\r\n  @return map-get($main-color, $key);\r\n}\r\n$accent-palette: (\r\n  50 : #ecf5fb,\r\n  100 : #cee6f6,\r\n  200 : #aed6f0,\r\n  300 : #8ec6e9,\r\n  400 : #75b9e5,\r\n  500 : #5dade0,\r\n  600 : #55a6dc,\r\n  700 : #4b9cd8,\r\n  800 : #4193d3,\r\n  900 : #3083cb,\r\n  A100 : #ffffff,\r\n  A200 : #dceeff,\r\n  A400 : #a9d5ff,\r\n  A700 : #90c9ff,\r\n  A800 : #EC4343,\r\n  contrast: (\r\n    50 : #000000,\r\n    100 : #000000,\r\n    200 : #000000,\r\n    300 : #000000,\r\n    400 : #000000,\r\n    500 : #ffffff,\r\n    600 : #000000,\r\n    700 : #000000,\r\n    800 : #000000,\r\n    900 : #ffffff,\r\n    A100 : #000000,\r\n    A200 : #000000,\r\n    A400 : #000000,\r\n    A700 : #000000,\r\n    A800 : #000000\r\n  )\r\n);\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
